<template>
    <div class="main-container">
        <el-form :inline="true" :model="searchForm" ref="searchForm" @keydown.enter.native="handleSearch" label-width="70px" size="small">

            <el-form-item label="商户号" prop="mchId">
                <el-input v-model="searchForm.mchId" placeholder="请输入商户号" style="width: 210px"></el-input>
            </el-form-item>

            <el-form-item label="商户名称" prop="mchName">
                <el-input v-model="searchForm.mchName" placeholder="请输入商户主体名称" style="width: 210px"></el-input>
            </el-form-item>
            
            <el-form-item label="商户主题" prop="mchCompanyName">
                <el-input v-model="searchForm.mchCompanyName" placeholder="请输入商户主题" style="width: 210px"></el-input>
            </el-form-item>
            
            <el-form-item>
                <el-button icon="el-icon-search" type="primary" @click="handleSearch" size="small">查询</el-button>
                <el-button @click="handleReset" size="small">重置</el-button>
            </el-form-item>
        </el-form>

        <el-button  icon="el-icon-plus" type="primary" size="small" @click="handleAdd" v-if="pagePermission.includes('add')">添加</el-button>

        <el-table border :data="data" size="small" style="width:100%;margin-top:10px;" v-loading="isLoading">
            <el-table-column type="index" label="所属代理商" align="center" width="100" fixed="left"></el-table-column>
            <el-table-column prop="mchName" label="商户名称" width="130"></el-table-column>
            <el-table-column prop="mchId" label="商户号" width="100"></el-table-column>
            <el-table-column prop="mchKey" label="商户秘钥" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="mchCompanyName" label="商户主体" width="130"></el-table-column>
            <el-table-column prop="hasBankCre" label="企业付款到银行卡" width="140" align="center">
                <template slot-scope="{row}">
                    <el-tag type="danger" size="mini" v-if="row.hasBankCre == 0">未开通</el-tag>
                    <el-tag type="success" size="mini" v-if="row.hasBankCre == 1">已开通</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="bankWithdrawalRate" label="银行卡提现手续费" width="120" ></el-table-column>
            <el-table-column prop="hasCreditFunction" label="企业付款到微信" width="140" align="center">
                <template slot-scope="{row}">
                    <el-tag type="danger" size="mini" v-if="row.hasCreditFunction == 0">未开通</el-tag>
                    <el-tag type="success" size="mini" v-if="row.hasCreditFunction == 1">已开通</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="wxCreditWay" label="微信到账方式" width="150" align="center">
                <template slot-scope="{row}">
                    <el-tag type="danger" size="mini" v-if="row.wxCreditWay == 0">企业付款到微信零钱</el-tag>
                    <el-tag type="success" size="mini" v-if="row.wxCreditWay == 1">商家转账到零钱</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="wxWithdrawalRate" label="微信提现手续费" width="120"></el-table-column>
            <el-table-column prop="wxWithdrawalRate" label="微信提现额度" width="120">
                <template slot-scope="{row}">
                    <span>{{row.toWxMin}} - {{ row.toWxMax }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="wxWithdrawalRate" label="银行卡提现额度" width="120">
                <template slot-scope="{row}">
                    <span>{{row.toBankMin}} - {{ row.toBankMax }}</span>
                </template>
            </el-table-column>

          <!-- <el-table-column prop="apiV3Cert" label="apiV3证书序列号值" width="160" show-overflow-tooltip></el-table-column> -->
          <!-- <el-table-column prop="apiV3Key" label="v3支付协议秘钥" width="160" show-overflow-tooltip></el-table-column> -->
          <!-- <el-table-column prop="serviceId" label="支付分服务ID" width="120"></el-table-column> -->
            <el-table-column label="操作" fixed="right"  width="160" align="center">
                <template slot-scope="{row}">
                    <el-button type="primary" size="mini" @click="handleEdit(row)" v-if="pagePermission.includes('edit')">编辑</el-button>
                    <el-button type="danger" size="mini" @click="handleDelete(row)" v-if="pagePermission.includes('delete')">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div style="text-align: right; padding: 10px 20px 0 0;">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[10, 20, 50]"
            :current-page.sync="searchForm.current" :page-size="searchForm.pageSize" @current-change="handleChangePage" @size-change="changePageSize"></el-pagination>
        </div>

        <el-dialog :title="!modelForm.id ? '新增' : '编辑'" width="1000px" :visible.sync="isShow" append-to-body destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false">
            <el-form :inline="true" :model="modelForm" ref="modelForm" label-width="150px" size="small" :rules="ruleModelForm">
                <el-form-item label="商户名称" prop="mchName">
                    <el-input v-model="modelForm.mchName" placeholder="请输入商户名称" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item label="商户主体名称" mchCompanyName="mchCompanyName">
                    <el-input v-model="modelForm.mchCompanyName" placeholder="请输入商户主体名称" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item label="商户id" prop="mchId">
                    <el-input v-model="modelForm.mchId" placeholder="请输入商户id" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item label="商户秘钥" prop="mchKey">
                    <el-input v-model="modelForm.mchKey" placeholder="请输入商户秘钥" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item label="apiclient_cert.p12" prop="keyPath">
                    <el-input v-model="modelForm.keyPath" placeholder="请上传apiclient_cert.p12证书" style="width:568px" readonly></el-input>
                    <el-upload action="/room/df-wx/merchant/cert/upload"
                        :headers="accessToken"
                        name="file"
                        :data="{
                            type: 1,
                            mchId: modelForm.mchId
                        }"
                        accept=".p12"
                        :before-upload="handleBeforeUpload"
                        :on-success="handleSuccessCert"
                        :show-file-list="false"
                        :max-size="5120"
                        :limit="1"
                        ref="upload1"
                        style="display:inline">
                        <el-button size="small" type="primary" style="margin-left: 5px">上传文件</el-button>
                    </el-upload>
                </el-form-item>

                <el-form-item label="apiclient_key.pem" prop="privateKeyPath">
                    <el-input v-model="modelForm.privateKeyPath" placeholder="请上传apiclient_key.pem文件" style="width: 570px" readonly></el-input>
                    <el-upload action="/room/df-wx/merchant/cert/upload"
                        :headers="accessToken"
                        name="file"
                        :data="{
                            type: 2,
                            mchId: modelForm.mchId
                        }"
                        accept=".pem"
                        :before-upload="handleBeforeUpload"
                        :on-success="handleSuccessKey"
                        :show-file-list="false"
                        :max-size="5120"
                        :limit="1"
                        ref="upload2"
                        style="display:inline">
                        <el-button size="small" type="primary" style="margin-left: 5px">上传文件</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="apiclient_cert.pem" prop="privateCertPath">
                    <el-input v-model="modelForm.privateCertPath" placeholder="请上传apiclient_cert.pem文件" style="width: 570px" readonly></el-input>
                    <el-upload action="/room/df-wx/merchant/cert/upload"
                        :headers="accessToken"
                        name="file"
                        :data="{
                            type: 3,
                            mchId: modelForm.mchId
                        }"
                        accept=".pem"
                        :before-upload="handleBeforeUpload"
                        :on-success="handleSuccessCertPem"
                        :show-file-list="false"
                        :max-size="5120"
                        :limit="1"
                        ref="upload3"
                        style="display:inline">
                        <el-button size="small" type="primary" style="margin-left: 5px">上传文件</el-button>
                    </el-upload>
                </el-form-item>

                <el-form-item label="apiV3证书序列号" prop="apiV3Cert">
                    <el-input v-model="modelForm.apiV3Cert" placeholder="请输入apiV3证书序列号" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item label="apiV3key" prop="apiV3Key">
                    <el-input v-model="modelForm.apiV3Key" placeholder="请输入apiV3key" style="width: 230px"></el-input>
                </el-form-item>
                <div>
                    <el-form-item label="企业付款到微信" prop="hasCreditFunction">
                        <el-radio-group v-model="modelForm.hasCreditFunction" style="width: 230px">
                            <el-radio :label="0">未开通</el-radio>
                            <el-radio :label="1">已开通</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="微信到账方式" prop="wxCreditWay" v-if="modelForm.hasCreditFunction == 1">
                        <el-radio-group v-model="modelForm.wxCreditWay">
                            <el-radio :label="0">企业付款到微信零钱</el-radio>
                            <el-radio :label="1">商家转账到零钱</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="提现手续费" prop="wxWithdrawalRate" v-if="modelForm.hasCreditFunction == 1">
                        <el-input v-model="modelForm.wxWithdrawalRate" placeholder="提现手续费" style="width: 230px">
                            <template slot="append">%</template>
                        </el-input>
                    </el-form-item>

                    <el-form-item label="最小提现金额" prop="toWxMin" v-if="modelForm.hasCreditFunction == 1">
                        <el-input v-model="modelForm.toWxMin" placeholder="请输入金额限制" style="width: 230px"></el-input>
                    </el-form-item>

                    <el-form-item label="最大提现金额" prop="toWxMax" v-if="modelForm.hasCreditFunction == 1">
                        <el-input v-model="modelForm.toWxMax" placeholder="请输入金额限制" style="width: 230px"></el-input>
                    </el-form-item>
                </div>

                <div>
                    <el-form-item label="企业付款到银行卡" prop="hasBankCre">
                        <el-radio-group v-model="modelForm.hasBankCre" style="width: 230px">
                            <el-radio :label="0">未开通</el-radio>
                            <el-radio :label="1">已开通</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="提现手续费" prop="bankWithdrawalRate" v-if="modelForm.hasBankCre == 1">
                        <el-input v-model="modelForm.bankWithdrawalRate" placeholder="提现手续费" style="width: 230px">
                            <template slot="append">%</template>
                        </el-input>
                    </el-form-item>

                    <el-form-item label="最小提现金额" prop="toBankMin" v-if="modelForm.hasBankCre == 1">
                        <el-input v-model="modelForm.toBankMin" placeholder="最小提现金额" style="width: 230px"></el-input>
                    </el-form-item>

                    <el-form-item label="最大提现金额" prop="toBankMax" v-if="modelForm.hasBankCre == 1">
                        <el-input v-model="modelForm.toBankMax" placeholder="最大提现金额" style="width: 230px"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer">
                <el-button type="text" @click="isShow = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit('modelForm')">提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import qs from "qs";
    export default {
        computed: {
            pagePermission() {
                return this.$store.state.pagePermission;
            }
        },
        data(){
            const valiRate= (rule, value, callback) => {
                if (value && !/(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/.test(value)) {
                    callback(new Error('手续费只能输入大于0的数(最多保留2位小数)'));
                } else {
                    callback();
                }

            };


            const valiBankMin = (rule, value, callback) => {
                value = Number(value) || null;
                if (value < 2 || !value ||  !/^\d+(\.\d{1,2})?$/.test(value) || (value > this.modelForm.toBankMax)) {
                    callback(new Error('微信最小金额不能为空且不能小于2元或者大于最大提现金额'));
                } else {
                    // this.$refs.modelForm.validateField("toBankMax")
                    callback();
                }
            };

            const valiBankMax = (rule, value, callback) => {
                value = Number(value) || null;
                if (value > 20000 || value < this.modelForm.toBankMin || !value ||  !/^\d+(\.\d{1,2})?$/.test(value)) {
                    callback(new Error('银行卡最大金额不能为空且不能大于20000元(不能小于最小提现金额)'));
                }else{
                    // this.$refs.modelForm.validateField("toBankMin")
                    callback();
                }
            };

            const valiWxMin = (rule, value, callback) => {
                value = Number(value) || null;
                if (value < 2 || !value ||  !/^\d+(\.\d{1,2})?$/.test(value) || (value > this.modelForm.toWxMax)) {
                    callback(new Error('微信最小金额不能为空且不能小于2元或者大于最大提现金额'));
                } else {
                    // this.$refs.modelForm.validateField("valiWxMax")
                    callback();
                }
            };
            const valiWxMax = (rule, value, callback) => {
                value = Number(value) || null;
                if (value > 20000 || value < this.modelForm.toWxMin || !value ||  !/^\d+(\.\d{1,2})?$/.test(value)) {
                    callback(new Error('微信最大金额不能为空且不能大于20000元(不能小于最小提现金额)'));
                }else{
                    // this.$refs.modelForm.validateField("valiWxMin")
                    callback();
                }
            };
            return{
                accessToken: {},
                searchForm:{
                    mchId:'',
                    mchName:"",
                    mchCompanyName: "",
                    current:1,
                    size:10
                },
                data:[],
                total:0,
                isShow:false,
                submitLoading:false,
                title:'',
                modelForm:{
                    mchName: "",
                    mchId:'',
                    mchKey:'',
                    keyPath:'',
                    apiV3Cert:'',
                    apiV3Key:'',
                    hasCreditFunction:0,
                    wxCreditWay:0,
                    hasBankCre:0,
                    privateKeyPath:'',
                    privateCertPath:'',
                    wxWithdrawalRate:'',
                    bankWithdrawalRate:'',
                    toBankMin:'',
                    toBankMax:'',
                    toWxMin:'',
                    toWxMax:'',
                },
                ruleModelForm:{
                    mchName:[{ required: true, message: "商户主体名称不能为空", trigger: 'blur'}],
                    mchId:[{ required: true, message: "商户ID不能为空", trigger: 'blur'}],
                    mchKey:[{ required: true, message: "商户秘钥不能为空", trigger: 'blur'}],
                    hasCreditFunction:[{ required: true, message: "是否已开通企业付款", trigger: 'blur'}],
                    wxCreditWay:[{ required: true, message: "请选择微信到账方式", trigger: 'blur'}],
                    hasBankCre:[{ required: true,  message: "是否开通企业付款到银行卡", trigger: 'blur'}],
                    keyPath:[{ required: true,  message: "请上传证书", trigger: 'change'}],
                    privateKeyPath:[{ required: true,  message: "apiclient_key.pem证书文件路径不能为空", trigger: 'change'}],
                    privateCertPath:[{ required: true,  message: "apiclient_cert.pem证书文件路径不能为空", trigger: 'change'}],
                    wxWithdrawalRate:[{ required: true,  validator: valiRate, trigger: 'blur'}],
                    bankWithdrawalRate:[{ required: true,  validator: valiRate, trigger: 'blur'}],
                    toBankMin:[{ required: true, validator: valiBankMin,  trigger: 'blur'}],
                    toBankMax:[{ required: true, validator: valiBankMax,  trigger: 'blur'}],
                    toWxMin:[{ required: true, validator: valiWxMin,  trigger: 'blur'}],
                    toWxMax:[{ required: true, validator: valiWxMax,  trigger: 'blur'}],
                },
                isLoading:false,
            }
        },
        created() {
            this.getTableData();
        },
        methods:{
            handleSuccessCert(res, file) {
                this.$refs.upload1.clearFiles();
                if (res.code == 200) {
                    this.modelForm.keyPath = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            },
            handleSuccessKey(res, file) {
                this.$refs.upload2.clearFiles();
                if (res.code == 200) {
                    this.modelForm.privateKeyPath = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            },
            handleSuccessCertPem(res, file) {
                this.$refs.upload3.clearFiles();
                if (res.code == 200) {
                    this.modelForm.privateCertPath = res.data;

                } else {
                    this.$message.error(res.msg);
                }
            },
            handleBeforeUpload() {

                if(!this.modelForm.mchId) {
                    this.$message.error('请先输入商户id');
                }
                return !!this.modelForm.mchId;
            },
            getTableData(){
                this.isLoading = true;
                this.getRequest('/df-wx/merchant/page',this.searchForm).then(res=>{
                    this.isLoading = false;
                    let data = res.data;
                    if(data.code == 200){
                        this.data = data.data.records;
                        this.total = data.data.total;
                    }
                })
            },
            handleSearch(){
                this.searchForm.current = 1;
                
                this.getTableData();
            },
            handleReset(){
                this.searchForm = {
                    mchId:'',
                    mchName:"",
                    mchCompanyName: "",
                    current:1,
                    size:10
                }

                this.getTableData();
            },
            handleChangePage(v) {
                this.searchForm.current = v;
                this.getTableData();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.searchForm.current = 1;
                this.getTableData();
            },

            handleAdd(){
                this.isShow = true;
                this.modelForm = {
                    mchName: "",
                    mchId:'',
                    mchKey:'',
                    keyPath:'',
                    apiV3Cert:'',
                    apiV3Key:'',
                    hasCreditFunction:0,
                    wxCreditWay:0,
                    hasBankCre:0,
                    privateKeyPath:'',
                    privateCertPath:'',
                    wxWithdrawalRate:'',
                    bankWithdrawalRate:'',
                    toBankMin:'',
                    toBankMax:'',
                    toWxMin:'',
                    toWxMax:'',
                }
            },
            handleEdit(row){
                this.title = '编辑';
                
                this.getRequest(`/df-wx/merchant/detail?id=${row.id}`).then(res=>{
                    this.submitLoading = false;
                    let data = res.data;
                    if (data.code == 200) {
                        this.isShow = true;
                        this.modelForm = data.data;
                    } 
                })

            },
            handleSubmit(name){
                let _this = this;
                this.$refs[name].validate((valid)=>{

                    if(valid){
                        this.submitLoading = true;
                        // var formdata = new FormData();
                        // for(let key in this.modelForm) {
                        //     formdata.append(key,this.modelForm[key]);
                        // }

                        if(this.modelForm.id) {

                            this.putRequest('/df-wx/merchant/editWxMerchant',this.modelForm).then(res=>{
                                this.submitLoading = false;
                                let data = res.data;
                                if (data.code == 200) {
                                    this.isShow = false;

                                    this.$message.success("操作成功");
                                    this.getTableData();
                                } 
                            })
                        } else {
                            delete this.modelForm.id;
                            this.postRequest('/df-wx/merchant/addWxMerchant',this.modelForm).then(res=>{
                                this.submitLoading = false;
                                let data = res.data;
                                if(data.code == 200){
                                    this.$message.success('添加成功');
                                    this.isShow = false;
                                    this.getTableData();
                                }
                            })
                        }
                    }
                })
            },
            
            handleDelete(row){

                this.$confirm(`您确定要删除该数据?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest('/df-wx/merchant/removeWxMerchant',{id:row.id}).then(res=>{
                        let data = res.data;
                        if(data.code == 200){
                            this.$message.success('删除成功');
                            this.getTableData();
                        } else {
                            this.$message.warning(data.msg);
                        }
                    })
                });

            }
        },
        mounted(){
            
            this.accessToken = {
                "Authorization": localStorage.getItem('Token'),
            }
            
        }

    }
</script>
